import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faTimes } from "@fortawesome/free-solid-svg-icons";

export const PopoutHeader = ({ togglePopout, getWindowBox, title, parentId }) => {
    const onMouseUp = () => {
        document.onmouseup = null;
        document.onmousemove = null;
    };

    const onMouseDown = (e) => {
        if (e.button !== 0) {
            return;
        }

        e.stopPropagation();
        e.preventDefault();

        document.onmouseup = onMouseUp;
        document.onmousemove = onMouseMove;
    };

    const onMouseMove = (e) => {
        const target = document.getElementById(parentId);

        if (!target) {
            return;
        }

        //Pixel offset so mouse stays hovered over button when dragging
        const offset = {
            x: 15,
            y: 15,
        };

        let translateX = e.clientX - offset.x + "px";
        let translateY = e.clientY - offset.y + "px";
        const wRect = getWindowBox();
        const tgtRect = target.getBoundingClientRect();
        const scrollBarWidth = window.innerWidth - document.body.clientWidth;

        if (e.clientX <= 0) {
            translateX = 0;
        }

        if (e.clientY <= 0) {
            translateY = 0;
        }

        if (e.clientX > wRect.right - tgtRect.width) {
            translateX = wRect.right - tgtRect.width - scrollBarWidth + "px";
        }

        if (e.clientY > wRect.bottom - tgtRect.height) {
            translateY = wRect.bottom - tgtRect.height + "px";
        }

        Object.assign(target.style, { transform: `translateX(${translateX}) translateY(${translateY})` });
    };

    return (
        <div className="popout-controls">
            <div
                className="button-drag"
                onMouseDown={onMouseDown}
            >
                <FontAwesomeIcon icon={faGripVertical} />
            </div>
            <h4>{title}</h4>
            <div
                className="button-close"
                onClick={() => {
                    togglePopout(false);
                }}
            >
                <FontAwesomeIcon icon={faTimes} />
            </div>
        </div>
    );
};
